import { RouterRoute } from '@fsd/shared/types';

export const FINANCE_ROUTES: Record<string, RouterRoute> = {
  PAYMENT_METHODS: {
    PATH: '/finance/new/payment-methods',
    NAME: 'new-payment-methods',
  },
  PAYMENT_METHODS_VERIFICATION: {
    PATH: '/finance/payment-methods/verification',
    NAME: 'payment-methods-verification',
  },
  DEPOSIT: {
    PATH: '/finance/deposit',
    NAME: 'deposit',
  },
  FINANCE_WITHDRAW: {
    PATH: '/finance/withdraw',
    NAME: 'finance-withdraw',
  },
  EDIT_MODE_PAYMENT_METHOD: {
    PATH: ':paymentType/:uid/edit',
    NAME: 'edit-payment-method',
  },
  FINANCE_WITHDRAW_REQUEST_CREATED: {
    PATH: '/finance/withdraw/request-created',
    NAME: 'finance-withdraw-request-created',
  },
  CREATE_PAYMENT_METHOD: {
    PATH: '/finance/payment-methods/create',
    NAME: 'finance-payment-methods-create',
  },
  CREATE_CARD_PAYMENT_METHOD: {
    PATH: '/finance/payment-methods/card/create',
    NAME: 'finance-payment-methods-create-card',
  },
  UPDATE_CARD_PAYMENT_METHOD: {
    PATH: '/finance/payment-methods/card/:uuid',
    NAME: 'finance-payment-methods-update-card',
  },
  CREATE_CRYPTO_PAYMENT_METHOD: {
    PATH: '/finance/payment-methods/crypto/create',
    NAME: 'finance-payment-methods-create-crypto',
  },
  CREATE_EXCHANGER_PAYMENT_METHOD: {
    PATH: '/finance/payment-methods/exchanger/create',
    NAME: 'finance-payment-methods-create-exchanger',
  },
  TRANSFER: {
    PATH: '/finance/transfer',
    NAME: 'transfer',
  },
  OPERATIONS_HISTORY: {
    PATH: '/finance/operations-history',
    NAME: 'finance-operations-history',
  },
  OPERATIONS_HISTORY_ITEM: {
    PATH: '/finance/operations-history/:id',
    NAME: 'finance-operations-history-item',
  },
  CREATE_EPS_PAYMENT_METHOD: {
    PATH: '/finance/payment-methods/eps/create',
    NAME: 'finance-payment-methods-eps-create',
  },
  UPDATE_EPS_PAYMENT_METHOD: {
    PATH: '/finance/payment-methods/eps/update/:uuid',
    NAME: 'finance-payment-methods-eps-update',
  },
  COMMISSION_COMPENSATION: {
    PATH: '/finance/commission-compensation',
    NAME: 'finance-commission-compensation',
  },
  CREATE_BANK_PAYMENT_METHOD: {
    PATH: '/finance/payment-methods/bank/create',
    NAME: 'finance-payment-methods-bank-create',
  },
};
